import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LogoMark } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-sand px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-line bg-bone p-10">
        <LogoMark className="h-10 w-10 text-pine" />
        <h1 className="mt-6 font-display text-3xl tracking-tighter text-pine">Admin sign in</h1>
        <p className="mt-2 text-sm text-ink/60">Veridian Education Foundation CMS</p>
        <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.2em] text-ink/60">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-0 border-b border-line bg-transparent py-3 text-base focus:border-pine focus:ring-0"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.2em] text-ink/60">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-0 border-b border-line bg-transparent py-3 text-base focus:border-pine focus:ring-0"
              data-testid="admin-password-input"
            />
          </div>
          {error && (
            <p
              className="border border-terra/40 bg-terra/10 px-4 py-3 text-sm text-terra"
              data-testid="admin-login-error"
            >
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="btn-sweep w-full bg-pine py-4 text-sm font-semibold text-sand disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
